module.exports = __webpack_public_path__ + "img/02.51f09b6e.jpg";